/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LinkedCardBox from "../LinkedCardBox/LinkedCardBox";
import linkedCardsHomePage from "./linkedCardsHomePage";
import linkedCardsServiceworld from "./linkedCardsServiceworld";
import linkedCardsServiceworldEmploymentLaw from "./linkedCardsServiceworldEmploymentLaw";
import linkedCardsEmploymentLaw from "./linkedCardsEmploymentLaw";
import Container from "../Container/Container";
import linkedCardsGuidebook from "./linkedCardsGuidebook";
import { IconWrapperProps } from "../IconWrapper/IconWrapper";

type AreaSelectionProps = {
  linkedCardList?: "home" | "serviceworld" | "employmentLaw" | "serviceworldEmploymentLaw" | "guidebook";
  sectionPadding?: boolean;
  mobileCtaText?: string;
};

const AreaSelection = ({ sectionPadding = true, linkedCardList = "home", mobileCtaText = "JETZT STARTEN" }: AreaSelectionProps) => {
  let linkedCards: {
    icon: IconWrapperProps["icon"];
    heading: string;
    subHeading: string;
    link: string;
  }[] = linkedCardsHomePage;

  switch (linkedCardList) {
    default:
    case "home":
      linkedCards = linkedCardsHomePage;
      break;
    case "serviceworld":
      linkedCards = linkedCardsServiceworld;
      break;
    case "serviceworldEmploymentLaw":
      linkedCards = linkedCardsServiceworldEmploymentLaw;
      break;
    case "employmentLaw":
      linkedCards = linkedCardsEmploymentLaw;
      break;
    case "guidebook":
      linkedCards = linkedCardsGuidebook;
      break;
  }

  return (
    <Container sectionPadding={sectionPadding}>
      <LinkedCardBox linkedCards={linkedCards} mobileCtaText={mobileCtaText} carouselLabel={"Rechtsgebiete"} />
    </Container>
  );
};

export default AreaSelection;
